import React from 'react';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SEO = ({ title, description, canonicalUrl, image, type = 'website', jsonLd }) => {
  const siteTitle = 'Shagun Surfaces';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Plăci Ceramice, Parchet & Obiecte Sanitare`;
  const defaultDesc = 'Plăci ceramice, parchet laminat și obiecte sanitare premium. Gresie, faianță, Kronotex, SPC. Showroom Brașov. Livrare în toată România.';
  const desc = description || defaultDesc;
  const imgSrc = image?.startsWith('/api') ? `${API_URL}${image}` : image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content={siteTitle} />
      {imgSrc && <meta property="og:image" content={imgSrc} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {imgSrc && <meta name="twitter:image" content={imgSrc} />}

      {/* Schema.org JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
